import axios from "axios";

export default class GET_INSTAGRAM {
  constructor(amount) {
    this.api_php = "/assets/api/getInstagram.php?amount=" + amount;
    this.data = [];
    this.get();
  }

  get() {
    axios
      .get(this.api_php)
      .then( res => {
        const $container = $('[data-plugin="instagram"]').empty();
        this.data = res.data.media.data;
        if( this.data.length > 0 ) {
          this.data.forEach( media => {
            const $item = $(`<a href="${media.permalink}" target="_blank" class="instagram__item"/>`);
            switch( media.media_type ) {
              case 'IMAGE':
                $item.append(`<img src="${media.media_url}" alt="${media.caption}" width="172" />`);
                break;
              case 'CAROUSEL_ALBUM':
                $item.append(`<img src="${media.media_url}" alt="${media.caption}" width="172" />`); 
                $item.addClass('is-carousel');
                break;
              case 'VIDEO':
                $item.append(`<img src="${media.thumbnail_url}" width="172" />`);
                $item.addClass('is-video');
                break;
            }
            $item.appendTo( $container );
          });
        }else {
          $container.append(`<small class="d-block p-3 text-center text-black-50 font-monospace">Data not found</small>`);
        }
      })
      .catch(err => {
        console.log(err);
      });
  }
}